<template>
  <LottScanWin v-if="state.isScan == 3" :line="state.line" :lotId="state.lotId" :data="state.data" :token="state.token" :back="back" />
  <LottScanFail v-if="state.isScan == 2" :lotId="state.lotId" :back="back" />
  <LottScan v-if="state.isScan == 1" :isMobile="state.isMobile" :scan="scan" />
  <LottScanMain v-if="state.isScan == 0" :scan="scan" />
</template>

<script setup>
import LottScan from '@/LottScan.vue'
import LottScanWin from '@/LottScanWin.vue'
import LottScanFail from '@/LottScanFail.vue'
import LottScanMain from '@/LottScanMain.vue'

import { reactive, nextTick } from 'vue'

const state = reactive({
  isScan: 0,  //0 MAIN   1 SCANING 2 FAIL 3 WIN
  token: '',
  lotId: 0,
  data: {},
  line: '',

  isMobile: false,
})

const getIsMobile = () => {
  let sUserAgent = navigator.userAgent.toLowerCase();
  if (/ipad|iphone|macintosh/.test(sUserAgent)) {
    //跳转移动端页面
    // console.log("IOS");
    return true;
  } else if (/android/.test(sUserAgent)) {
    // console.log("ANDROID");
    return true;
  } else {
    //跳转pc端页面
    return false;
  }
}

const getQueryParam = param => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

const init = () => {
  state.token = getQueryParam('token');
  state.lotId = getQueryParam('lotId');
  state.line = getQueryParam('line');

  state.isMobile = getIsMobile();

  window.addEventListener('message', function (event) {
    if (event.data === 'CallFunction') {
      window.parent.myFunctionInParent();
    }
  }, false);
}

init();

const scan = (t, d) => {
  state.isScan = t;

  if (d) state.data = d;
}

const back = (t) => {
  state.isScan = t;
}
</script>

<style></style>